import { Pipe, PipeTransform } from '@angular/core';
import { formatSsn } from 'app/helpers/formatSsn';

@Pipe({ name: 'ssn' })
export class SsnPipe implements PipeTransform {
    constructor() {}
    transform(ssn) {
        return formatSsn(ssn);
    }
}
